module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-comp"
  }, [_c('div', {
    staticClass: "background",
    class: {
      'full-screen': _vm.isFullSceenActive
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "header"
  }, [_c('div', {
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.cameraObj.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'full-screen': _vm.isFullSceenActive
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "camera-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'live'),
      expression: "tabs[selectedTabIndex] === 'live'"
    }],
    staticClass: "content"
  }, [(!_vm.cameraObj.isOnline) ? _c('div', {
    staticClass: "svg-icon",
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0zm0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.cameraObj.isOnline) ? _c('img', {
    attrs: {
      "src": _vm.cameraObj.liveSnapshotUrl
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.thumbnailVideoUrls[_vm.selectedDateIndex] && !_vm.isFullSceenActive) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), (!_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "loading-status"
  }, [_vm._v("\n              Loading...\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-info"
  }, [_c('div', {
    staticClass: "info-title",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    },
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tabs[_vm.selectedTabIndex]) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                " + _vm._s(_vm.hours[_vm.selectedHourIndex] + ':' + _vm.minutes[_vm.selectedMinuteIndex] + ':00 ' + _vm.getAmPm(_vm.selectedHourIndex)) + "\n              ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "!thumbnailVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "thumbnailVideoUrls[selectedDateIndex]"
    }],
    ref: "thumbnailVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex] && !_vm.isFullSceenActive),
      expression: "thumbnailVideoUrls[selectedDateIndex] && !isFullSceenActive"
    }],
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), (!_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "loading-status"
  }, [_vm._v("\n              Loading...\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "video-info",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    }
  }, [_c('div', {
    staticClass: "info-title",
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isRecordingVideoActive ? _vm.tabs[_vm.selectedTabIndex] : (+_vm.thumbnailVideoPlaybackRates[_vm.thumbnailVideoDefaultPlaybackRateIndex] * 10 * 60) + 'x') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                " + _vm._s(_vm.hours[_vm.selectedHourIndex] + ':' + _vm.minutes[_vm.selectedMinuteIndex] + ':00 ' + _vm.getAmPm(_vm.selectedHourIndex)) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "playback-control-container"
  }, [_c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastRewind()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickPlayAndPause()
      }
    }
  }, [(!_vm.isThumbnailVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastForward()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])])]) : _vm._e()])])], 1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "camera-control-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "timeline-container"
  }, [_c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedDateIndex,
      "totalItems": _vm.dates.length
    }
  }, _vm._l((_vm.dates), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        'selected': index === _vm.selectedDateIndex,
          'has-recording': _vm.thumbnailVideoUrls[index]
      },
      on: {
        "click": function($event) {
          _vm.onClickDate(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedHourIndex,
      "totalItems": _vm.hours.length
    }
  }, _vm._l((_vm.hours), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedHourIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickHour(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value + _vm.getAmPm(index)) + "\n            ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedMinuteIndex,
      "totalItems": _vm.minutes.length
    }
  }, _vm._l((_vm.minutes), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedMinuteIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickMinute(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, _vm._l((_vm.tabs), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "action-btn",
      class: {
        'selected': index === _vm.selectedTabIndex,
          'playback': value === 'playback'
      },
      on: {
        "click": function($event) {
          _vm.selectTab(index)
        }
      }
    }, [_vm._v(_vm._s(value))])
  }))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06131fc1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CameraComp.vue
// module id = 270
// module chunks = 1